import { currencyFloatToInteger } from './currency';

export function isValidBasePrice(props: { basePrice: string | null; price: string | null }) {
  // Treat empty strings as null
  const normalizedPrice = props.price === '' ? null : props.price;
  const normalizedBasePrice = props.basePrice === '' ? null : props.basePrice;

  // If price is null, basePrice must also be null
  if (normalizedPrice == null && normalizedBasePrice != null) {
    return false;
  }

  // Check if price is a non-numerical string (word)
  if (normalizedPrice != null && isNaN(parseFloat(normalizedPrice))) {
    return false;
  }

  // Check if basePrice is a non-numerical string (word)
  if (normalizedBasePrice != null && isNaN(parseFloat(normalizedBasePrice))) {
    return false;
  }

  const price = normalizedPrice == null ? null : currencyFloatToInteger(normalizedPrice);
  const basePrice = normalizedBasePrice == null ? null : currencyFloatToInteger(normalizedBasePrice);

  if (price == null && basePrice == null) {
    return true;
  }

  if (price == null) {
    return false;
  }

  if (basePrice == null) {
    return true;
  }

  if (basePrice < 0) {
    return false;
  }

  return basePrice <= price;
}
